var _style, _path, _defs, _path2, _defs2, _path3, _defs3, _path4, _defs4, _path5, _defs5, _path6, _defs6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 560",
    style: {
      enableBackground: "new 0 0 288 560"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{opacity:0.75;mask:url(#SVGID_00000062902315680259316730000001168403603354750360_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_00000035500888609096292420000017989505220768330902_);}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_00000173126412065693902540000003718784477235191695_);}\n\t.st6{opacity:0.75;mask:url(#SVGID_00000124151665045049640430000000314904105603380409_);}\n\t.st7{fill:url(#SVGID_00000172425922459012147250000014417072647037148565_);}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_00000096036674724660813160000014033678670258242489_);}\n\t.st9{opacity:0.75;mask:url(#SVGID_00000039829821260769141870000002188692720240924602_);}\n\t.st10{fill:url(#SVGID_00000075866636839768662880000008261222743120926389_);}\n\t.st11{filter:url(#Adobe_OpacityMaskFilter_00000021107180918310936020000001323479763980987018_);}\n\t.st12{opacity:0.75;mask:url(#SVGID_00000114040311120976337720000017919943774893546373_);}\n\t.st13{fill:url(#SVGID_00000160174195016454014070000005385512131025820586_);}\n\t.st14{filter:url(#Adobe_OpacityMaskFilter_00000020386777009004538280000004778578446220213416_);}\n\t.st15{opacity:0.75;mask:url(#SVGID_00000091721263853133476040000017781882596171051449_);}\n\t.st16{fill:url(#SVGID_00000141450590482231073220000009965062465774282118_);}\n\t.st17{filter:url(#Adobe_OpacityMaskFilter_00000170962166849295115690000009220699434754471605_);}\n\t.st18{opacity:0.75;mask:url(#SVGID_00000080196630037052867750000002926606365507421335_);}\n\t.st19{fill:url(#SVGID_00000003796696123867537690000017481447928167500454_);}\n\t.st20{fill:url(#SVGID_00000145736931267349984440000005282893102912147092_);}\n\t.st21{opacity:0.15;fill:#682A00;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.2729,
    y1: 300.4129,
    x2: 197.9417,
    y2: 206.1876,
    gradientTransform: "matrix(0.9914 -0.131 0.131 0.9914 -32.4145 27.9154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01834122,
    style: {
      stopColor: "#FFD578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FF2016"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7076,
    style: {
      stopColor: "#AE140F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    style: {
      stopColor: "#710C09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9466,
    style: {
      stopColor: "#4B0605"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#3C0404"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.9,318.5c-0.4,0.3-4.1-20.6,57.2-45.5c19.8-8.1,29.5-19.8,29.5-19.8s-2,14.8-17.6,26 C212.4,291.8,163.8,304.8,160.9,318.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 160.7,
    y: 253.3,
    width: 86.8,
    height: 65.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 160.7,
    y: 253.3,
    width: 86.8,
    height: 65.2,
    id: "SVGID_00000169542564283258255370000007953758386104465280_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 92,
    height: 70,
    xlinkHref: "26A090EA6E3D077D.jpg",
    transform: "matrix(1 0 0 1 158 251)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75,
      mask: "url(#SVGID_00000169542564283258255370000007953758386104465280_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.9,318.5c-0.4,0.3-4.1-20.6,57.2-45.5c19.8-8.1,29.5-19.8,29.5-19.8s-2,14.8-17.6,26 C212.4,291.8,163.8,304.8,160.9,318.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127742924373156142210000003449888177315004036_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.286,
    y1: 297.3181,
    x2: 208.286,
    y2: 193.7531,
    gradientTransform: "matrix(0.9914 -0.131 0.131 0.9914 -32.4145 27.9154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01834122,
    style: {
      stopColor: "#FFD578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FF2016"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7076,
    style: {
      stopColor: "#AE140F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    style: {
      stopColor: "#710C09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9466,
    style: {
      stopColor: "#4B0605"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#3C0404"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127742924373156142210000003449888177315004036_)"
    },
    d: "M223.3,265.2 c0.3,1.1,7.1-49.1-26.9-58.3c0,0-18,25.5-0.5,53.3c0,0-4.5-17.2,6-32.6C201.9,227.5,211.2,226.8,223.3,265.2z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000048479091559787254590000010852039155021572534_",
    filterUnits: "userSpaceOnUse",
    x: 188.2,
    y: 206.9,
    width: 35.9,
    height: 58.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 188.2,
    y: 206.9,
    width: 35.9,
    height: 58.3,
    id: "SVGID_00000098213364938717921600000004899814271636532390_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000048479091559787254590000010852039155021572534_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 41,
    height: 64,
    xlinkHref: "26A090EA6E3D077F.jpg",
    transform: "matrix(1 0 0 1 186 204)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75,
      mask: "url(#SVGID_00000098213364938717921600000004899814271636532390_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M223.3,265.2c0.3,1.1,7.1-49.1-26.9-58.3c0,0-18,25.5-0.5,53.3c0,0-4.5-17.2,6-32.6 C201.9,227.5,211.2,226.8,223.3,265.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139251639353232544070000007893258748846723460_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.2361,
    y1: 310.632,
    x2: 148.6483,
    y2: 208.3293,
    gradientTransform: "matrix(0.9914 -0.131 0.131 0.9914 -32.4145 27.9154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01834122,
    style: {
      stopColor: "#FFD578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FF2016"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7076,
    style: {
      stopColor: "#AE140F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    style: {
      stopColor: "#710C09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9466,
    style: {
      stopColor: "#4B0605"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#3C0404"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139251639353232544070000007893258748846723460_)"
    },
    d: "M208.3,274.6c0,0-20.1-31.8-65.3-18.7 c0,0,12,27.4,39.8,26.6c0,0-17.3-8.2-20.5-18.2C162.2,264.3,197.6,262.8,208.3,274.6z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000120558373103733364340000003662751225854455979_",
    filterUnits: "userSpaceOnUse",
    x: 142.9,
    y: 252.7,
    width: 65.3,
    height: 29.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 142.9,
    y: 252.7,
    width: 65.3,
    height: 29.8,
    id: "SVGID_00000127036471193897449620000016028994031123207565_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000120558373103733364340000003662751225854455979_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 71,
    height: 35,
    xlinkHref: "26A090EA6E3D077A.jpg",
    transform: "matrix(1 0 0 1 140 250)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75,
      mask: "url(#SVGID_00000127036471193897449620000016028994031123207565_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M208.3,274.6c0,0-20.1-31.8-65.3-18.7c0,0,12,27.4,39.8,26.6c0,0-17.3-8.2-20.5-18.2 C162.2,264.3,197.6,262.8,208.3,274.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130609773879659190720000013308719301724723133_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.4486,
    y1: 297.8288,
    x2: 228.4486,
    y2: 208.9283,
    gradientTransform: "matrix(0.9914 -0.131 0.131 0.9914 -32.4145 27.9154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01834122,
    style: {
      stopColor: "#FFD578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FF2016"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7076,
    style: {
      stopColor: "#AE140F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    style: {
      stopColor: "#710C09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9466,
    style: {
      stopColor: "#4B0605"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#3C0404"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130609773879659190720000013308719301724723133_)"
    },
    d: "M228.3,264.5 c-0.2,0.9,1.2-30.5-11.2-47.2c0,0,2.1-4.9,6.6-7.3C223.7,210,237.6,229.8,228.3,264.5z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000039110443058146032300000008241746892082286241_",
    filterUnits: "userSpaceOnUse",
    x: 217.1,
    y: 210,
    width: 14.4,
    height: 54.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 217.1,
    y: 210,
    width: 14.4,
    height: 54.5,
    id: "SVGID_00000052824090689610019390000017430069789555386263_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000039110443058146032300000008241746892082286241_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 19,
    height: 59,
    xlinkHref: "26A090EA6E3D077B.jpg",
    transform: "matrix(1 0 0 1 215 208)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75,
      mask: "url(#SVGID_00000052824090689610019390000017430069789555386263_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M228.3,264.5c-0.2,0.9,1.2-30.5-11.2-47.2c0,0,2.1-4.9,6.6-7.3C223.7,210,237.6,229.8,228.3,264.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128478485965281485200000011629112723807221384_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.5968,
    y1: 287.2365,
    x2: 206.2174,
    y2: 221.0884,
    gradientTransform: "matrix(0.9914 -0.131 0.131 0.9914 -32.4145 27.9154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01834122,
    style: {
      stopColor: "#FFD578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FF2016"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7076,
    style: {
      stopColor: "#AE140F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    style: {
      stopColor: "#710C09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9466,
    style: {
      stopColor: "#4B0605"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#3C0404"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128478485965281485200000011629112723807221384_)"
    },
    d: "M210.3,271.1c0,0-17.7-18.5-7.5-40.8 C202.8,230.2,217.9,244,210.3,271.1z"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000093146226800612844320000005719223216177364629_",
    filterUnits: "userSpaceOnUse",
    x: 199.6,
    y: 230.2,
    width: 12.8,
    height: 40.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 199.6,
    y: 230.2,
    width: 12.8,
    height: 40.8,
    id: "SVGID_00000025419189899684480950000008607237437427880344_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000093146226800612844320000005719223216177364629_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 18,
    height: 46,
    xlinkHref: "26A090EA6E3D0785.jpg",
    transform: "matrix(1 0 0 1 197 228)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75,
      mask: "url(#SVGID_00000025419189899684480950000008607237437427880344_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M210.3,271.1c0,0-17.7-18.5-7.5-40.8C202.8,230.2,217.9,244,210.3,271.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057128408820959651890000017198811777188222355_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.4766,
    y1: 304.8724,
    x2: 174.7724,
    y2: 236.8209,
    gradientTransform: "matrix(0.9914 -0.131 0.131 0.9914 -32.4145 27.9154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01834122,
    style: {
      stopColor: "#FFD578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FF2016"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7076,
    style: {
      stopColor: "#AE140F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    style: {
      stopColor: "#710C09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9466,
    style: {
      stopColor: "#4B0605"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#3C0404"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057128408820959651890000017198811777188222355_)"
    },
    d: "M201.7,278.1c0,0-6-11.1-35.3-11.5 C166.4,266.7,176.4,280.1,201.7,278.1z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000145034471316910852530000005751113402026884268_",
    filterUnits: "userSpaceOnUse",
    x: 166.4,
    y: 266.7,
    width: 35.3,
    height: 11.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 166.4,
    y: 266.7,
    width: 35.3,
    height: 11.7,
    id: "SVGID_00000092444059857625202760000011495282793865211833_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000145034471316910852530000005751113402026884268_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 40,
    height: 17,
    xlinkHref: "26A090EA6E3D0787.jpg",
    transform: "matrix(1 0 0 1 164 264)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75,
      mask: "url(#SVGID_00000092444059857625202760000011495282793865211833_)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M201.7,278.1c0,0-6-11.1-35.3-11.5C166.4,266.7,176.4,280.1,201.7,278.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Fire"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067196758415674249950000005746016756914728123_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.5462,
    y1: 321.3566,
    x2: 84.3683,
    y2: 378.6555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01834122,
    style: {
      stopColor: "#FFD578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4523,
    style: {
      stopColor: "#FF2016"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4748,
    style: {
      stopColor: "#F41E15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6154,
    style: {
      stopColor: "#B3150F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7431,
    style: {
      stopColor: "#800E0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8537,
    style: {
      stopColor: "#5B0807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    style: {
      stopColor: "#440505"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#3C0404"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067196758415674249950000005746016756914728123_)"
    },
    d: "M247.8,299.5c0,54-41.2,98.3-93.8,103.3 c-42,0.3-53.8-24.8-48.1-50.4c11.8,4.8,24.7,7.4,38.2,7.4c51.1,0,93.4-37.9,100.3-87.1C246.6,281.3,247.8,290.3,247.8,299.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106113745709946419160000014783587876707518143_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.1797,
    y1: 366.7124,
    x2: 191.3177,
    y2: 44.4905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01834122,
    style: {
      stopColor: "#FFD578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    style: {
      stopColor: "#FF2016"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#3C0404"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106113745709946419160000014783587876707518143_)"
    },
    d: "M109.4,285.6c1-0.2,32.8-7.7,48.6-27.7 c0,0,0.6,28.6-30.7,57.9c-10.7,10-18.5,23.4-21.4,36.7c-5.7,25.5,6.1,50.7,48.1,50.4c-3.3,0.3-6.6,0.5-10,0.5 c-57.3,0-103.8-46.5-103.8-103.8c0-11.4,1.1-21.8,2.9-31.1c11-54.2,49.9-77.4,74.3-107.6c18.3-22.7,28.3-49.3,12.2-96.1 c0,0,36.1,39.2,38.2,95.4c0.5,11.8-0.6,24.4-3.8,37.6C157.3,225.2,141.1,255.1,109.4,285.6z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M101.1,305.1c34,9,56.9-47.2,56.9-47.2s0.6,28.6-30.7,57.9c-10.7,10-18.5,23.4-21.4,36.7 c-5.7,25.5,6.1,50.7,48.1,50.4c-1.8,0.2-3.7,0.3-5.5,0.4h0c-16.3,0.1-37.6-5.6-53.9-24.4C67.7,348,58.1,285.8,113.7,234 c9.5-11.6,27.6-29.8,33.9-66.5c8.6-50.9-11-90.4-17.8-102.8c0,0,36.1,39.2,38.2,95.4c0.5,11.8-0.6,24.4-3.8,37.6 c-6.7,27.5-23,57.5-54.7,87.9C95.1,297.3,101.1,305.1,101.1,305.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5960a40c55bc6e536d14f96786e6fb5a.svg";
export { ForwardRef as ReactComponent };